import React from "react";
import { withStyles, Button } from "@material-ui/core";
import PropTypes from "prop-types";
import cx from "classnames";
import { defaultFont } from "../../assets/jss/material-dashboard-react.jsx";

//import { CustomInput, IconButton as SearchButton } from "../../components";

import buttonStyle from "../../assets/jss/material-dashboard-react/buttonStyle";

class AddButton extends React.Component {
    constructor(props, context){
        super(props.context)
        console.log("Button created")
    }
  state = {
    open: false
  };

  handleClick = () => {
    this.setState({ open: !this.state.open });
  };

  handleClose = () => {
    this.setState({ open: false });
  };
  render( ...props ) {
    if(!this.props.ispasschange){
        return null;
      }
    const { logout } = this.props;
    const { open } = this.state;
    const {
        classes,
    color,
    round,
    children,
    fullWidth,
    disabled,
    ...rest
      } = this.props;

      const btnClasses = cx({
        [classes[color]]: color,
        [classes.round]: round,
        [classes.fullWidth]: fullWidth,
        [classes.disabled]: disabled
      });
    return (
        <Button {...rest} className={classes.button + " " + btnClasses}>
      {children}
    </Button>
    );
  }
}

AddButton.propTypes = {
  classes: PropTypes.object.isRequired,
  color: PropTypes.oneOf([
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "rose",
    "white",
    "simple",
    "transparent"
  ]),
  round: PropTypes.bool,
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool
};

export default withStyles(buttonStyle)(AddButton);



// WEBPACK FOOTER //
// ./src/components/CustomButtons/AddButton.jsx